const truckTypes = [
  {
    value: `vehicle`,
    description: `Cavalo`
  },
  {
    value: `truck_body`,
    description: `Carroceria`
  },
  {
    value: `utility`,
    description: `Utilitário`
  }
]

export { truckTypes }
